/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class ToggleControl extends React.Component {
	render() {
		let label = this.props.activeLabel,
			toggleClass = classnames('toggle-control', this.props.toggleClass,
				{
					'inactive': (this.props.active === false) ? true : false,
					'control-disabled': (this.props.controlState === 'disabled') ? true : false,
				}),
			labelBlock = null,
			labelBlockRight = null,
			ariaActive = (this.props.active) ? "true" : "false",
			labelClass = classnames('toggle-label', this.props.labelClass),
			clickHandler = this.props.callback,
			dataAttributes = {},
			helpButton = null;

		if (this.props.controlState === 'disabled') {
			clickHandler = null;
		}

		if (!this.props.noLabel) {
			if (this.props.helpButton !== undefined) {
				helpButton = this.props.helpButton;
			}

			if (!this.props.active) {
				label = this.props.inactiveLabel;
			}
			labelBlock = (
				<div className={labelClass}>
					{label} {helpButton}
				</div>
			);

			if (this.props.labelPlacement === 'right') {
				labelBlockRight = (
					<div className={labelClass + ' right-label'}>
						{label} {helpButton}
					</div>
				);
				labelBlock = null;
			}
		}

		for (let key in this.props) {
			if (key.match(/^data-/)) {
				dataAttributes[key] = this.props[key];
			}
		}

		return (
			<div className={toggleClass}
				role="checkbox"
				aria-checked={ariaActive}
				aria-label={this.props.ariaLabel}
				aria-disabled={this.props.controlState === 'disabled' || undefined}
				tabIndex={clickHandler ? 0 : undefined}
				onClick={clickHandler}
				onKeyDown={clickHandler ? (e) => {
					// Space toggles it, as it does a native checkbox
					if (e.key === ' ') {
						e.preventDefault();
						clickHandler(e);
					}
				} : undefined}
				data-togglestate={this.props.active}
				data-field={this.props.linkedField}
				{...dataAttributes}>
				{labelBlock}
				<div className="toggle-control-well">
					<div className="toggle-button"></div>
				</div>
				{labelBlockRight}
			</div>
		);
	}
};

ToggleControl.displayName = "ToggleControl";

ToggleControl.propTypes = {
	active: PropTypes.bool,
	callback: PropTypes.func,
	noLabel: PropTypes.bool,
	linkedField: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	activeLabel: PropTypes.string,
	inactiveLabel: PropTypes.string,
	labelClass: PropTypes.string,
	labelPlacement: PropTypes.string,
	controlState: PropTypes.string,
	toggleClass: PropTypes.string
};

ToggleControl.defaultProps = {
	active: true,
	callback: null,
	noLabel: false,
	linkedField: '',
	activeLabel: 'Active',
	inactiveLabel: 'Inactive',
	labelClass: '',
	labelPlacement: 'left',
	controlState: '',
	toggleClass: ''
};

export default ToggleControl;
